
(function () {
  const TRIGGER_SELECTOR = ".c-live-chat, .mobile-live-chat";
  const CHAT_SELECTOR = "shopify-chat, shopify-agent";
  const LEGACY_WRAPPER = "#shopify-chat";

  function openLegacyChat() {
    const wrapper = document.querySelector(LEGACY_WRAPPER);
    const hostElement = wrapper?.querySelector("inbox-online-store-chat");
    if (!hostElement) return;

    wrapper.style.visibility = "visible";
    hostElement.shadowRoot?.querySelector(".chat-toggle")?.click();
  }

  function openChat() {
    const chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) {
      openLegacyChat();
      return;
    }

    if (typeof chat.show === "function") {
      chat.show();
      return;
    }
    customElements.whenDefined(chat.localName).then(function () {
      customElements.upgrade(chat);
      if (typeof chat.show === "function") {
        chat.show();
      } else {
        chat.setAttribute("open", "");
      }
    });
  }
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(TRIGGER_SELECTOR)) return;

    event.preventDefault();
    openChat();
  });
})();
